/**
 * Ridimensiona e ricomprime una foto lato client prima dell'upload.
 * Gli scatti da fotocamera possono pesare diversi MB: su GSM debole in campo
 * questo porta l'invio del rapportino (fino a 7 foto obbligatorie + firme)
 * a impiegare anche decine di minuti. Riducendo a un lato massimo ragionevole
 * e ricomprimendo in JPEG si tagliano drasticamente tempi di upload e rischio
 * di richieste che restano appese senza timeout.
 */
export async function compressImage(file: File, maxDim = 1600, quality = 0.72): Promise<File> {
  if (!file.type.startsWith('image/')) return file
  try {
    const bitmap = await createImageBitmap(file)
    const scale = Math.min(1, maxDim / Math.max(bitmap.width, bitmap.height))
    const width = Math.round(bitmap.width * scale)
    const height = Math.round(bitmap.height * scale)

    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const ctx = canvas.getContext('2d')
    if (!ctx) return file
    ctx.drawImage(bitmap, 0, 0, width, height)
    bitmap.close?.()

    const blob: Blob | null = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', quality))
    if (!blob || blob.size >= file.size) return file // già piccola: tieni l'originale

    return new File([blob], file.name.replace(/\.\w+$/, '.jpg'), { type: 'image/jpeg' })
  } catch {
    return file // fallback: browser senza createImageBitmap o formato non decodificabile
  }
}
